import styles from './core-entity-content-container.module.css';

type Props = {
    children: React.ReactNode;
    hasFullHeightSidebar?: boolean;
};

export function CoreEntityContentContainer(props: Props) {
    if (props.hasFullHeightSidebar) {
        return <>{props.children}</>;
    }

    return <div className={styles['content-container']}>{props.children}</div>;
}
